export default function HeadTailRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                `}
            </style>


            <div class="modal fade show" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Heads &amp; Tails</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To guess whether the coin flip result will be Heads or Tails.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b>Coin Flip:</b> A fair coin will be flipped. The coin can land on one of two sides: Heads or Tails.</p>
                                            <p class="pt20"><b>Placing Bets:</b> Players can place a bet on Heads or Tails. The odds for each runner are 1.98.</p>
                                            <p class="pt20"><b>Winning Condition:</b> If the coin lands on the side you bet on (Heads or Tails), you win the bet.</p>
                                            <p class="pt20"><b>Example:</b> If you bet on Heads and the coin lands on Heads, you win your bet and receive a payout according to the odds (1.98)</p>
                                        </div>

                                        <h3><b>Payout </b></h3>
                                        <div>
                                            <div>
                                                <div>
                                                    <p class="pt20">For each winning bet:</p>
                                                    <p class="pt20">The payout is calculated as follows:</p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>Bet Type</th>
                                                                <th>Odds</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Heads</th>
                                                                <th>1.98</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Tails</th>
                                                                <th>1.98</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
